import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

// Containers
import LaunchpadContainer from './Containers/LaunchpadContainer';
import ForgetPasswordContainer from './Containers/ForgetPasswordContainer';
import LoginContainer from './Containers/LoginContainer';
import ProjectOverviewContainer from './Containers/ProjectOverviewContainer';
import SignupContainer from './Containers/SignupContainer';
import ShootSetupContainer from './Containers/ShootSetupContainer';
import WelcomeContainer from './Containers/WelcomeContainer';
import ProjectRobotStatusDashboardContainer from './Containers/ProjectRobotStatusDashboardContainer';
import SettingsContainer from './Containers/SettingsContainer';
import ArchiveProjectsContainer from 'Containers/ArchiveProjectsContainer';
import ForgetPasswordConfirmContainer from 'Containers/ForgetPasswordConfirmContainer';
import OrgRobotStatusDashboardContainer from './Containers/OrgRobotStatusDashboardContainer';
import ProjectIntegrationsContainer from './Containers/ProjectIntegrationsContainer';

// Pages
import NotFound from 'Pages/NotFoundPage';
import AIRHelpPage from 'Pages/AIRHelpPage';
import ScannedProjectListPage from 'Pages/ScannedProjectListPage';

const PageRouter = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={LoginContainer} exact />
        <Route path="/signup" component={SignupContainer} exact />
        <Route
          path="/forget-password"
          component={ForgetPasswordContainer}
          exact
        />
        <Route
          path="/reset-password"
          component={ForgetPasswordConfirmContainer}
          exact
        />
        <Route path="/" component={WelcomeContainer} exact />
        <Route path="/settings" component={SettingsContainer} />
        {/* default page */}
        {/* <Route path="/" component={SettingsContainer} exact /> */}
        <Route
          path="/project/overview/:project_id"
          component={ProjectOverviewContainer}
          exact
        />
        <Route
          path="/project/launchpad/:project_id"
          component={LaunchpadContainer}
          exact
        />
        <Route
          path="/project/robot-status-dashboard/:project_id"
          component={ProjectRobotStatusDashboardContainer}
          exact
        />
        <Route
          path="/project/integrations/:project_id"
          component={ProjectIntegrationsContainer}
          exact
        />
        <Route
          path="/project/shoot-setup/:project_id"
          component={ShootSetupContainer}
          exact
        />
        <Route
          path="/archive-projects"
          component={ArchiveProjectsContainer}
          exact
        />
        <Route
          path="/robot-status-dashboard"
          component={OrgRobotStatusDashboardContainer}
          exact
        />
        <Route path="/air-help" component={AIRHelpPage} exact />
        <Route
          path="/qr-code/:air_id"
          component={ScannedProjectListPage}
          exact
        />
        <Route path="/404" component={NotFound} />
        <Redirect to="/404" />
      </Switch>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        draggable={false}
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
    </BrowserRouter>
  );
};

export default PageRouter;
